import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const serviceCategory = createAsyncThunk('serviceCategory', async ({ navigate,shop_id }) => {

    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL +'public/'+ `salon_service_categorywise`,
            params: {
                'shop_id': shop_id,
            },
            headers: { "Content-Type": "application/json"}

        })
        return res
    } catch (error) {
        return error.response
    }
})

const serviceCategorySlice = createSlice({
    name: 'serviceCategory',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(serviceCategory.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(serviceCategory.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default serviceCategorySlice.reducer;
